/* eslint-disable react-refresh/only-export-components -- False positive for use right now. No iimediate need to split. https://github.com/ArnaudBarre/eslint-plugin-react-refresh/issues/22*/
import React, { useState, useCallback, useEffect } from 'react';
import { isAuthenticated } from '../authentication/isAuthenticated';
import { login } from '../authentication/login';
import { logout } from '../authentication/logout';
import { signedOn } from '../authentication/signedOn';
import { getUser } from '../utility/sessionStorage';
import { missingValidRoles } from '../authentication/missingValidRoles';
import { EnvConfig, getConfig } from '../../config/envconfig';
import { User } from '../authentication/User.types';

export const AuthContext = React.createContext({} as AuthContextType);

export type AuthContextProps = {
    children: React.JSX.Element;
};

export type AuthContextType = {
    config: EnvConfig | undefined;
    getAccessToken: () => string | null;
    isAuthenticated: () => boolean;
    login: (config: EnvConfig) => void;
    signedOn: (hash: string) => void;
    signOut: () => void;
    user: User;
};

export const AuthenticationContext = ({ children }: AuthContextProps) => {
    const conf = getConfig();
    const [user, setUser] = useState(getUser());
    useEffect(() => {
        if (missingValidRoles(user)) {
            return logout(user);
        }
    }, [conf, user]);

    const signedOnCb = useCallback(
        (hash: string) => {
            return signedOn(hash, setUser);
        },
        [setUser]
    );

    const loginCb = useCallback((config: EnvConfig) => {
        return login(config);
    }, []);

    const logoutCb = useCallback(() => {
        return logout(user);
    }, [user]);

    const isAuthenticatedCb = useCallback(() => {
        return isAuthenticated(user);
    }, [user]);

    const getAccessToken = useCallback(() => {
        return user && user.access_token ? user.access_token : null;
    }, [user]);

    const state: AuthContextType = {
        config: conf,
        getAccessToken,
        isAuthenticated: isAuthenticatedCb,
        login: loginCb,
        signedOn: signedOnCb,
        signOut: logoutCb,
        user
    };

    return (
        <AuthContext.Provider value={state}>{children}</AuthContext.Provider>
    );
};

export default AuthenticationContext;
